var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"data-component-name":_vm.$options.name}},[(_vm.isKnown)?[_vm._v(_vm._s(_vm.value))]:_c('span',{staticClass:"text-danger fw-bold"},[_vm._v(_vm._s(_vm.unavailableText))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }